(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/square-color-jackpot/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_layouts/square-color-jackpot/assets/javascripts/render-component.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let format;
let bannerHelpers;
if (svs.isServer) {
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  format = trinidadCore.components.require('utils', 'format').api;
  bannerHelpers = trinidadCore.components.require('banner_common', 'banner-helpers');
} else {
  format = svs.utils.format;
  bannerHelpers = svs.banner_common.banner_helpers;
}

async function renderComponent(model, widgetInfo, position, req, res) {
  var _model$contentType, _model$layoutConfig, _res$locals$squareCo;
  let hbsCompiled;
  let features;
  let isAdmin;
  const trackingStringTitle = format.safeString(model.title) || model.title;
  const contentType = (model === null || model === void 0 || (_model$contentType = model.contentType) === null || _model$contentType === void 0 ? void 0 : _model$contentType.split(':').pop()) || 'banner';
  if (svs.isServer) {
    var _res$locals$features, _res$locals;
    const hbs = global.internalInstances.get('hbs');
    hbsCompiled = hbs.cache['components-banner_layouts-square_color_jackpot-square_color_jackpot'];
    features = (_res$locals$features = res === null || res === void 0 || (_res$locals = res.locals) === null || _res$locals === void 0 ? void 0 : _res$locals.features) !== null && _res$locals$features !== void 0 ? _res$locals$features : [];
    isAdmin = req.userSession.hasRole(req.userSession.roles.INTERNAL);
  } else {
    var _svs$core;
    hbsCompiled = svs.banner_layouts.square_color_jackpot.templates.square_color_jackpot;
    features = ((_svs$core = svs.core) === null || _svs$core === void 0 || (_svs$core = _svs$core.data) === null || _svs$core === void 0 ? void 0 : _svs$core.features) || [];
    isAdmin = svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL);
  }
  const product = model === null || model === void 0 || (_model$layoutConfig = model.layoutConfig) === null || _model$layoutConfig === void 0 ? void 0 : _model$layoutConfig.product;
  const jackpots = svs.isServer ? (_res$locals$squareCo = res.locals['square-color-jackpot']) === null || _res$locals$squareCo === void 0 ? void 0 : _res$locals$squareCo.jackpots : svs.banner_layouts.square_color_jackpot.data.jackpots;
  const _bannerHelpers$format = bannerHelpers.formatJackpot({
      product,
      jackpots
    }),
    jackpotLabel = _bannerHelpers$format.jackpotLabel,
    jackpotString = _bannerHelpers$format.jackpotString,
    secondaryJackpotString = _bannerHelpers$format.secondaryJackpotString;
  return hbsCompiled(_objectSpread(_objectSpread({}, model.layoutConfig), {}, {
    contentType,
    features,
    isAdmin,
    callToActions: model.callToActions,
    crm: model.targetOffer || '',
    bannerId: model.id,
    jackpotLabel,
    jackpotString,
    secondaryJackpotString,
    clickTrackingString: "".concat(widgetInfo.widgetType, "/").concat(widgetInfo.trackingId, "/").concat(position, "/").concat(model.layoutType, "/").concat(trackingStringTitle),
    impressionTrackingString: "".concat(widgetInfo.widgetType, "/").concat(widgetInfo.trackingId, "/").concat(position, "/").concat(model.layoutType, "/").concat(trackingStringTitle)
  })) || '';
}
if (svs.isServer) {
  module.exports = {
    renderComponent
  };
} else {
  Object.assign(svs.banner_layouts.square_color_jackpot, {
    renderComponent
  });
}

 })(window);